module.exports = __webpack_public_path__ + "ah.no1.c7ef4fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ah.no1.jpg
// module id = fT/H
// module chunks = 0